// src/services/tenantService.js
import api from './api';

export const createTenant = (data) => {
    return api.post('/tenants', data);
};

export const getTenants = () => {
    return api.get('/tenants');
};

export const updateTenant = (id, data) => {
    return api.put(`/tenants/${id}`, data);
};

export const getTenantUsers = (tenantId) => {
    return api.get(`/tenants/${tenantId}/users`);
};

export const addUserToTenant = (tenantId, userData) => {
    return api.post(`/tenants/${tenantId}/users`, userData);
};

export const deleteTenantUser = (tenantId, userId) => {
    return api.delete(`/tenants/${tenantId}/users/${userId}`);
};

export const updateTenantUser = (tenantId, userId, userData) => {
    return api.put(`/tenants/${tenantId}/users/${userId}`, userData);
};